import initSchoolAnimations from '../util/schoolAnimations';

export default {
	init() {
		// Hub della Scuola di Armando: le due colonne sono link diretti,
		// l'unica logica è quella delle animazioni comuni.
		initSchoolAnimations();
	},
	finalize() {},
};
